import { Module, ActionTree, MutationTree, GetterTree } from "vuex"
import { RootState } from "@/store/RootStore"
import { make } from "vuex-pathify"
import { StoreUtils } from "@/utils/StoreUtils"
import services from "@/services/Services"
import { ResourceLink } from "rp-components"

const namespaced: boolean = true

//===================================
// State
//===================================
export interface FileUploadState {}

export const state: FileUploadState = {}

//===================================
// Getters
//===================================
const getters: GetterTree<FileUploadState, RootState> = {
    ...make.getters(state)
}

//===================================
// Actions
//===================================
export const actions: ActionTree<FileUploadState, RootState> = {
    ...make.actions(state),

    async uploadMaintenanceResource({ dispatch }, payload: { resource: ResourceLink; file: File }) {
        await StoreUtils.withLoading(
            dispatch,
            async () => {
                if (payload.file.type.includes("image")) {
                    payload.file = await services.files.compressFile(payload.file)
                }
                const updatedResource = await services.files.uploadMaintenanceFile(payload.file)
                payload.resource.id = updatedResource.id
                payload.resource.url = updatedResource.url
                payload.resource.mimeType = updatedResource.mimeType
            },
            async (err: any) => {
                dispatch("setError", err, { root: true })
                // propagate exception to prevent addition of resource link
                throw err
            }
        )
    },

    async uploadResource({ dispatch }, payload: { resource: ResourceLink; file: File }) {
        await StoreUtils.withLoading(
            dispatch,
            async () => {
                if (payload.file.type.includes("image")) {
                    payload.file = await services.files.compressFile(payload.file)
                }
                const updatedResource = await services.files.uploadPublicFile(payload.file)
                payload.resource.id = updatedResource.id
                payload.resource.url = updatedResource.url
                payload.resource.mimeType = updatedResource.mimeType
            },
            async (err: any) => {
                dispatch("setError", err, { root: true })
                // propagate exception to prevent addition of resource link
                throw err
            }
        )
    },

    async uploadGuestInviteResource({ dispatch }, payload: { resource: ResourceLink; file: File }) {
        await StoreUtils.withLoading(
            dispatch,
            async () => {
                const updatedResource = await services.files.uploadGuestInviteFile(payload.file)
                payload.resource.id = updatedResource.id
                payload.resource.url = updatedResource.url
                payload.resource.mimeType = updatedResource.mimeType
            },
            async (err: any) => {
                dispatch("setError", err, { root: true })
                throw err
            }
        )
    }
}

//===================================
// Mutators
//===================================
export const mutations: MutationTree<FileUploadState> = {
    ...make.mutations(state)
}

//===================================
// Module
//===================================
export const fileUpload: Module<FileUploadState, RootState> = {
    namespaced,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
}
